module.exports = __webpack_public_path__ + "img/kerinfo.0e4f31db.png";